import __request__ from "routing/request";
export function acceptance(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiservice/ai/terms/acceptance", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function allTerms(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiservice/ai/terms/all", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function consents(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiservice/ai/terms/consents", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function addConsent(terms_and_conditions_version, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.aiservice/ai/terms/consents/${terms_and_conditions_version}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function latestTerms(requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.aiservice/ai/terms/latest", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
